const de = {
    enter_code: "Session-ID",
    connect: "Verbinden",
    check_your_internet_connection: "Prüfe deine Internetverbindung.",
    network_error: "Netzwerkfehler",
    server_error: "Serverfehler",
    check_server_connection: "Interner Serverfehler",
    downtime: "Down Time",
    server_is_currently_facing_downtime: "Server ist derzeit Ausfallzeiten konfrontiert",
    show_what_you_see: "Zeigen Sie, was Sie sehen,",
    by_joining_i_confirm_that_i_have_read_and_understand_the:
        "Ich bestätige, dass ich die Datenschutzerklärung gelesen habe und damit einverstanden bin.",
    privacy_policy: "Datenschutzerklärung",
    invalid_code: "Ungültige Sitzungs-ID",
    code_should_be_of_nine_digits: "Die Sitzungs-ID sollte 9-stellig sein",
    blitzz: "Blitzz",
    please_enter_your_name: "Bitte geben Sie Ihren Namen ein",
    maximum_value_is_30: "Name sollte weniger als 30 Zeichen.",
    please_enter_meeting_id: "Bitte geben Sie Ihren CODE",
    please_try_again: "Bitte versuche es erneut.",
    no_one_is_sharing_video: "Niemand teilt Video.",
    retry: "Wiederholen",
    reconnect: "Erneut verbinden",
    left_the_conversation: "Die Konversation verlassen",
    enabled_the_audio: "aktiviert den Audio",
    disabled_the_audio: "das Audio deaktiviert",
    enabled_the_video: "aktiviert das Video",
    disabled_the_video: "das Video deaktiviert",
    failed_to_join_room: "Fehlgeschlagen Raum zu betreten",
    alert: "Warnen",
    override_video_sharing_message: "Möchten Sie den aktuellen Bildschirm Aktie beenden und starten Sie Ihre Video-Sharing?",
    override_screen_sharing_message: "Möchten Sie die aktuelle Bildschirmfreigabe beenden möchte und starten Sie Ihren Bildschirm freigeben?",
    override_video_sharing_with_screen_capturing_message: "Möchten Sie das aktuelle Video beenden und starten Sie Ihren Bildschirm freigeben?",
    override_screen_sharing_with_video_sharing_message: "Möchten Sie den aktuellen Bildschirm Aktie beenden und starten Sie Ihre Video-Sharing?",
    yes: "Ja",
    cancel: "Stornieren",
    joined_the_call: "trat den Anruf",
    waiting_for_other_members_to_join_the_call: "Warten auf andere Mitglieder der Konferenz teilnehmen",
    warning: "Warnung",
    camera_permission_disabled: "Unfähig Kamera zugreifen",
    microphone_permission_disabled: "Zugriff auf Mikrofon nicht möglich.",
    location_permission_disabled: "Unfähig Standort zugreifen",
    storage_permission_disabled: "Unfähig Speicher zugreifen",
    permission_error_message_camera: "Bitte aktivieren Sie diese Kamera von Geräteeinstellungen.",
    permission_error_message_microphone: "Bitte aktivieren Mikrofon von Geräteeinstellungen.",
    permission_location_error_message: "Bitte aktivieren Sie diese Position von Geräteeinstellungen.",
    permission_storage_error_message: "Bitte aktivieren Sie Lagerung von Geräteeinstellungen.",
    give_permission: "Erlaubnis erteilen",
    please_wait_for_five_seconds_to_take_screenshot: "Bitte warten Sie 5 Sekunden ein weiteres Foto aufzunehmen",
    please_wait_for: "Bitte warte auf",
    seconds_to_take_screen_shot: "Sekunden ein weiteres Foto aufzunehmen.",
    second_to_take_screen_shot: "zweite ein weiteres Foto aufzunehmen.",
    invalid_information_received_from_server: "Ungültige Daten vom Server empfangen.",
    unable_to_share_screen_as_no_one_else_has_joined_the_conversation_yet: "Video kann nicht teilen, wie niemand sonst das Gespräch noch beigetreten",
    successfully_uploaded: "erfolgreich hochgeladen",
    disconnected: "Getrennt",
    call_ended_as_no_one_else_had_joined_the_call: "Disconnected wie niemand sonst verbunden.",
    application_update_required: "Anwendungs-Update erforderlich",
    update_required_message: "Sieht aus wie Sie auf eine ältere Version der Anwendung, beachten Sie bitte aus dem App Store aktualisieren.",
    update: "Aktualisieren",
    image_marking_started: "Bildmarkierung gestartet",
    image_marking_stopped: "Bild Markierung gestoppt",
    settings: "die Einstellungen",
    camera_permission_rationale: "Wir brauchen Zugriff auf die Kamera. Bitte geben Kamera Erlaubnis",
    microphone_permission_rationale: "Wir müssen den Zugriff auf das Mikrofon. Bitte geben Mikrofon Erlaubnis",
    location_permission_rationale: "Wir brauchen Zugriff auf Ihren Standort. Bitte geben Standort Erlaubnis",
    storage_permission_rationale: "Wir müssen den Zugriff auf Ihre Ablage. Bitte geben Speicher Erlaubnis",
    call_between_two_customers: "Der Agent nicht beigetreten ist, bitte versuchen Sie es erneut in einiger Zeit.",
    media_projection_permission_needed_for_screen_sharing: "Medien Projektion Erlaubnis für die Bildschirmfreigabe benötigt.",
    poor_network_connection: "Warnung! Schlechte Netzwerkverbindung",
    you_are_the_only_person_in_the_call: "Sie sind die einzige Person in dem Anruf",
    image_has_been_captured_and_started_uploading: "Bild wurde gefangen genommen und begann das Hochladen",
    version: "Ausführung",
    please_enter_the_code_provided_to_you: "Bitte geben Sie den Code, der Ihnen zur Verfügung gestellt.",
    start_screen_share: "Bildschirm freigeben",
    stop_screen_share: "Stoppen Sie die Freigabe",
    flip_camera: "Flip-Kamera",
    take_photo: "Foto machen",
    flash_off: "Blitz aus",
    flash_on: "Blitz an",
    start_markup: "Start Markup",
    stop_markup: "Stop-Markup",
    speaker_off: "Lautsprecher OFF",
    speaker_on: "Lautsprecher EIN",
    more: "Mehr",
    close: "Schließen",
    video_off: "Video OFF",
    video_on: "Video ON",
    start_video: "Video starten",
    stop_video: "Stop-Video",
    disconnect: "Trennen",
    mute: "Stumm",
    muted: "Stummschaltung aufheben",
    powered_by_blitzz: "Unterstützt von Blitzz",
    connecting_your_call: "In Verbindung gebracht. Warten auf andere Teilnehmer.",
    connected: "In Verbindung gebracht",
    pin_is_of_nine_digit: "Der Stift sollte von 9 Ziffer sein",
    preparing_image_for_markup: "Vorbereiten für Markup ...",
    clear_markup_confirmation: "Klares Bild Markups von allen Benutzern?",
    clear_markup: "klar Markup",
    clear: "klar",
    close_markup: "Schließen Markup",
    end_markup_confirmation: "Sind Sie sicher, dass Sie Markup schließen möchten?",
    end: "Ende",
    agent_has_ended_markup_cannot_continue_without_agent: "Agent beendet Markup. Kann nicht ohne Markup-Agenten weiter",
    joining_image_markup: "Lade Bild für Markup ...",
    cleared_markup: "Bild Markups für alle Benutzer gelöscht.",
    capturing_photo: "Capturing Foto ...",
    uploading: "Hochladen",
    image: "Bild",
    image_ready_for_markup: "Bild bereit zum Markup.",
    override_video: "Dies wird anderes Video zu stoppen. Wollen Sie fortfahren?",
    override_screen_share: "Dies wird andere Bildschirmfreigabe beenden. Wollen Sie fortfahren?",
    started_screen_share: "Gestartet Screenshare.",
    stopped_screen_share: "Gestoppt Screenshare.",
    clear_all: "Alles löschen",
    start_new_call_popup: "Neuen Anruf mit CODE",
    group_call_limit_reached: "Gruppenruf Grenze erreicht",
    contact_admin_to_increase_participant_limit:
        "Bitte warten Sie, bis ein anderer Teilnehmer die Verbindung getrennt hat, und versuchen Sie es dann erneut.",
    call_is_being_connected: "Anruf verbunden ist, versuchen Sie es später noch einmal.",
    show_recording_for_training_purpose: "Diese Sitzung wird aufgezeichnet.",
    you_are_sharing_the_screen: "Sie teilen den Bildschirm",
    location_colon: "Ort:",
    date_colon: "Datum:",
    image_for_markup_has_been_downloaded: "Bild für Markup heruntergeladen wurde",
    dismiss: "Entlassen",
    google_play_service_is_not_up_to_date: "Google Play-Service nicht mehr aktualisiert",
    rec: "Rec",
    you_are_offline: "Du bist offline.",
    markup: "Markup",
    exit: "Ausgang",
    video_unsupported: "Video nicht unterstützt",
    please_open_this_link_in_safari: "Bitte öffnen Sie diesen Link in Safari.",
    you_are_not_able_to_see_this_video: "Sie sind nicht in der Lage das Video zu sehen.",
    only_number_Allowed: "Nur Zahlen sind erlaubt.",
    permission_warning: "Permission Warnung",
    unable_to_join_call_please_try_after_sometime: "Anruf kann nicht beitreten. Bitte versuchen Sie es nach einiger Zeit",
    share_live_video: "Teilen Sie Ihre Live-Video?",
    share_your_screen: "Geben Sie Ihren Bildschirm?",
    unable_access_flash: "Nicht imstande, Flash Light zuzugreifen.",
    camera_unavailable_try_again: "Die Kamera ist nicht verfügbar, versuchen Sie es erneut.",
    unable_download_image_tomarkup: "Bild kann nicht vom Server heruntergeladen werden. Bitte versuchen Sie es erneut.",
    try_again: "Versuchen Sie es nochmal",
    markup_screen_appear_shortly: "Markup-Bildschirm erscheint in Kürze ...",
    confirm: "Bestätigen",
    start: "Start",
    could_not_find_endpoint: "Server kann nicht Endpunkt finden.",
    please_wait: "Warten Sie mal...",
    done: "Erledigt",
    ok: "OK",
    please_try_again_with_valid_agent_id: "Bitte versuchen Sie es erneut mit einem gültigen ID-Agent.",
    meeting_code_not_associated_with_agent: "Die Sitzungs-ID ist dieser Agenten-ID nicht zugeordnet.",
    powered_by: "Unterstützt von",
    failure: "Fehler",
    code: "Session-ID",
    start_new_call_question: "Neuen Anruf?",
    stop_sharing: "Hör auf zu teilen",
    reconnecting_call: "Wiederherstellen der Verbindung Anruf ...",
    unable_to_access_mircrophone_or_camera: "Kann Ihr Mikrofon oder Kamera zuzugreifen.",
    be_sure_to_allow_access_in_browser: "Achten Sie darauf, den Zugang in Ihren Browser-Einstellungen zu ermöglichen.",
    make_sure_you_have_microphone_camera_attached: "Vergewissern Sie sich, Kamera oder ein Mikrofon angebracht.",
    location_blocked_by_user: "Standort vom User geblockt",
    user_has_joined_the_call: "Der Benutzer hat den Anruf verbunden",
    are_you_sure_you_want_to_close_window: "Sind Sie sicher, dass Sie dieses Fenster schließen?",
    reset_guide: "Reset Führungs",
    open_in_google_maps: "Öffnen Sie in Google Maps",
    location_image_upload_failed: "Ort Bild-Upload fehlgeschlagen",
    uploading_image: "Hochladen von Bild",
    upload_failed: "Upload fehlgeschlagen",
    markup_is_in_progress: "Markup ist inprogress ...",
    select_language: "Sprache auswählen",
    checking_for_extension: "Überprüfen auf Verlängerung ...",
    start_incognito_mode_from_blitzz_screen_share_ext:
        "Um Bildschirm Aktie im Inkognito-Modus starten müssen Sie den Inkognito-Modus von Blitzz starten - Screen Share Erweiterung Ihres Browsers.",
    click_on: "Klicke auf",
    customize_and_control_menu: "Anpassen und Steuern Menü",
    more_tools: "Mehr Werkzeuge",
    extensions: "Erweiterungen",
    click_on_detail: "Klicken Sie auf Detail (Blitzz)",
    allow_in_incognito: "Lassen Sie inkognito in.",
    screen_share: "Bildschirm teilen",
    stop_share: "Stop-Anteil",
    save: "speichern",
    cancel_initcap: "Stornieren",
    yes_initcap: "Ja",
    message_title: "Botschaft",
    device_not_compatible: "Leider ist dieses Gerät nicht kompatibel.",
    please_download_our_app: "Bitte laden Sie unsere App fortzusetzen.",
    download_app: "Lade App herunter",
    this_browser_is_not_supported: "Dieser Browser wird derzeit nicht unterstützt.",
    open_in_chrome_or_install_mobile_app:
        "Bitte kopieren Sie diesen Link und fügen Sie ihn in die neueste Version von Google Chrome ein oder installieren Sie unsere Mobile App und versuchen Sie es erneut.",
    open_in_safari_or_install_mobile_app:
        "Bitte kopieren Sie diesen Link und fügen Sie ihn in die neueste Version des Safari-Browsers ein oder installieren Sie unsere mobile App und versuchen Sie es erneut.",
    open_in_chrome_and_try_again: "Bitte öffnen Sie diesen Link in der neuesten Version von Google Chrome und versuchen Sie es erneut.",
    okay_initcap: "okay",
    would_you_like_to_install_app_or_continue_browser: "Sie möchten unsere App installieren, mit Browser zu verbinden Meeting oder Continue?",
    continue_initcap: "Fortsetzen",
    webview_limited_support_message: "Für ein optimales Nutzungserlebnis öffnen Sie die Seite bitte im Chrome-Browser oder Ihrem Standardbrowser.",
    continue_anyway: "Trotzdem fortfahren",
    open_in_browser: "Im Browser öffnen",
    link_copied_open_in_browser: "Link kopiert! Falls sich der Browser nicht öffnet, fügen Sie den Link in Chrome ein.",
    add_blitzz_extension_to_screen_share: "In Blitzz Erweiterung Bildschirm Aktie",
    add_to_chrome_and_confirm: "‚In den Chrome & Bestätigen‘",
    add_extension: "Erweiterung hinzufügen",
    permission_error_message_camera_browser: "Bitte aktivieren Kamera von Browser-Einstellungen.",
    camera_not_found: "Kamera nicht gefunden",
    enable_camera_and_reconnect_call: "Sie benötigen eine Kamera aktivieren, aktualisieren Sie die Seite und Anruf wieder an.",
    permission_error_message_microphone_browser: "Bitte aktivieren Mikrofon von Browser-Einstellungen.",
    permission_error_message_location_browser: "Bitte aktivieren Sie den Standort über die Browsereinstellungen.",
    microphone_not_found: "Mikrofon nicht gefunden",
    enable_microphone_and_reconnect_call: "Sie benötigen Mikrofon aktivieren, aktualisieren Sie die Seite und Anruf wieder an.",
    download_failed: "Herunterladen fehlgeschlagen",
    continue_markup: "Weiter Markup",
    save_and_exit: "Speichern und Beenden Markup",
    exit_markup: "Beenden Markup",
    you_are_recording_the_conversation: "Sie nehmen nun das Gespräch.",
    make_sure_participant_know_they_are_being_recorded: "Achten Sie darauf, die Teilnehmer wissen, dass sie aufgezeichnet sind zu werden.",
    you_can_download_recordings_later: "Sie können anschließend die aufgenommene Datei herunterladen.",
    share_without_joining_session_lanuch_showme_enter_code:
        "Kann nicht teilen Bildschirm eine ShowMe Session, ohne daran teilzunehmen. Bitte starten Sie ShowMe von Blitzz, und geben Sie den Code, der Ihnen zur Verfügung gestellt.",
    call_limit_reach_contact_Admin_to_increase_limit:
        "Gruppenruf Grenze erreicht. Bitte kontaktieren Sie Ihren Administrator das Teilnehmerlimit oder warten Sie auf ein Mitglied zu erhöhen, um die Sitzung zu verlassen.",
    other_user_trying_share_screen_Video: "Andere Benutzer versucht, Bildschirm oder Video zu teilen",
    call_has_ended: "Anruf beendet",
    would_you_like_to_save_image: "Möchten Sie das Bild speichern?",
    audio_unsupported: "Audio wird nicht unterstützt",
    please_install_our_app_to_continue: "Bitte installieren Sie die App, um fortzufahren.",
    unable_to_play_remote_audio: "Nicht imstande, Remote-Audio zu spielen.",
    unable_to_playback_audio: "Kein Audio wiederzugeben.",
    unable_to_play_video: "Video kann nicht spielen.",
    unable_to_playback_video: "Video kann nicht wiedergegeben werden.",
    okay_cap: "Okay",
    pre_call_test: "Voranruftest",
    language: "Sprache",
    reset: "rücksetzen",
    zoom_in: "Hineinzoomen",
    zoom_out: "Rauszoomen",
    headset: "kopfhörer",
    bluetooth: "Bluetooth",
    live_pointer_enabled_message: "Live Pointer gestartet. Sie können den Zeiger durch Ziehen verschieben.",
    speaker: "Redner",
    live_pointer_disabled_message: "Live-Zeiger gestoppt",
    pointer: "Zeiger",
    network_quality: "Netzwerkqualität",
    participant: "Teilnehmer",
    you: "(Sie)",
    reconnecting: "Erneut verbinden",
    very_bad: "Sehr schlecht",
    bad: "Schlecht",
    poor: "Arm",
    good: "Gut",
    excellent: "Ausgezeichnet",
    loc: "Loc",
    expand: "Erweitern",
    collapse: "Zusammenbruch",
    network: "Netzwerk",
    ocr_inprogress: "OCR wird ausgeführt ...",
    select_area_extract_text: "Bereich auswählen, um Text zu extrahieren",
    text_copied: "Text kopiert",
    extract_text_from_image: "Text aus Bild extrahieren ...",
    not_extract_text_from_image: "Text konnte nicht aus dem Bild extrahiert werden.",
    try_again_clear_image_or_reselect_region:
        "Bitte versuchen Sie es mit einem klaren Bild erneut oder wählen Sie Ihren Extraktionsbereich erneut aus.",
    error: "Error",
    occured_while_receiving_doc: "ist beim Empfang des Dokuments aufgetreten.",
    return_to_video: "Zurück zum Video",
    save_entire_image: "Ganz speichern",
    save_cropped_image: "Cropped speichern",
    text_copied_to_clipboard: "Klicken Sie zum Kopieren",
    extract_text: "Text extrahieren",
    stop_pointer: "Zeiger stoppen",
    do_not_rotate_the_phone_live_pointer_message: "Drehen Sie das Gerät für ein besseres Seherlebnis nicht, während der Live-Zeiger aktiviert ist.",
    got_it_btn: "Ich habs!",
    speed_test: "Geschwindigkeitstest",
    duration: "Dauer",
    preparing_image_for_OCR: "Bild für die Textverarbeitung vorbereiten…",
    agent_extract_text_from_image: "Bitte warten Sie, Agent extrahiert Text aus dem erfassten Bild.",
    unable_download_image_to_ocr: "Das Bild kann nicht zur Verarbeitung heruntergeladen werden. Bitte versuchen Sie es erneut.",
    selected_area_is_small: "Der ausgewählte Bereich ist zu klein.",
    please_select_large_area: "Bitte wählen Sie einen großen Bildbereich.",
    zoom_level: "Zoomstufe",
    do_not_rotate_the_phone_markup_message: "Drehen Sie das Gerät für ein besseres Seherlebnis nicht, solange die Markierung aktiviert ist.",
    capturing: "Erfassen...",
    upload_completed: "Upload abgeschlossen",
    network_quality_not_available: "Netzwerkqualität nicht verfügbar",
    not_able_to_see_your_stream: "wird Ihren Stream nicht sehen können.",
    device_not_supported: "Gerät nicht unterstützt.",
    video_settings_need_to_be_configured_by_admin_web:
        "Die Videoeinstellungen müssen von Ihrem Administrator konfiguriert werden, um dieses Gerät zu unterstützen. Bitte wenden Sie sich an Ihren Unternehmensadministrator oder senden Sie eine E-Mail an",
    contact: "Kontakt",
    video_paused_by_agent: "Video vom Agenten angehalten",
    not_shared: "Nicht geteilt",
    network_type: "Netzwerkart",
    image_thumb_caption: "Bild:",
    saved_images: "Gespeicherte Bilder",
    update_your_browser_to_share_your_screen: "Aktualisieren Sie Ihren Browser auf die neueste Version, um Ihren Bildschirm freizugeben",
    try_these_option_to_have_better_experience: "Probieren Sie eine dieser Optionen für eine bessere Erfahrung.",
    some_features_are_not_supported_in_this_browser: "Einige Funktionen werden in diesem Browser nicht unterstützt.",
    unsupported_browser: "Nicht unterstützter Browser",
    permission_message_for_screenshare:
        "Die Zugriffsberechtigung für den Bildschirmbereich wurde verweigert, oder Ihre aktuelle Browserinstanz verfügt nicht über die Zugriffsberechtigung für die Bildschirmfreigabe.",
    go_to_system_preferences: "Gehen Sie zu den Systemeinstellungen",
    security_privacy: "Sicherheit",
    select_privacy_tab: "Wählen Sie die Registerkarte Datenschutz",
    screen_recording: "Bildschirmaufnahme",
    select_your_browser: "Wählen Sie Ihren Browser",
    use_chrome_to_share_your_screen: "Verwenden Sie den Chrome- oder Firefox-Browser, um Ihren Bildschirm freizugeben",
    there_was_an_error_trying_to_share_your_video: "Beim Versuch, Ihr Video freizugeben, ist ein Fehler aufgetreten.",
    please_stop_video_and_start_video_again_to_resume: "Bitte stoppe das Video und starte es erneut, um fortzufahren.",
    decline: "Ablehnen",
    agree: "Zustimmen",
    click_the_padlock: "Klicken Sie auf das Vorhängeschloss",
    to_the_left_of_a_web_page_address: "links neben der Adressleiste.",
    clear_blocked_permission_for_share_the_screen: 'Deaktivieren Sie alle gesperrten Bildschirmfreigabeberechtigungen im Abschnitt "Berechtigungen".',
    tips_colon: "Tipps:",
    your_internet_connection_is_unstable: "Ihre Internetverbindung ist instabil",
    participants_connection_unstable: "Die Internetverbindung von Teilnehmer <participantNum> ist instabil",
    enter_text_here: "Hier Text eingeben",
    text: "Text",
    rect: "Rect",
    draw: "Zeichnen",
    try_our_mobile_app: "In App öffnen",
    still_facing_issue_connect_mobile_app: "Wenn Sie immer noch auf ein Problem stoßen, verbinden Sie sich mit unserer mobilen App.",
    open_in_app: "In App öffnen",
    enable_microphone_from_browser_settings: "Aktivieren Sie das Mikrofon in den Browsereinstellungen.",
    enable_camera_from_browser_settings: "Aktivieren Sie die Kamera in den Browsereinstellungen.",
    unable_to_access_microphone: "Zugriff auf Mikrofon nicht möglich",
    participants_title: "Teilnehmer",
    bookmarks_title: "Lesezeichen",
    search_or_add_new_bookmark: "Suchen oder fügen Sie ein neues Lesezeichen hinzu",
    create_new_bookmark: "Neues Lesezeichen erstellen",
    press_enter_or_click_on_create_new_bookmark:
        "Drücken Sie die Eingabetaste oder klicken Sie auf Neues Lesezeichen erstellen, um ein neues Lesezeichen hinzuzufügen",
    tap_retry_to_load: "Tippen Sie zum Laden auf Wiederholen",
    bookmark_saved_with_image: "Lesezeichen mit Bild gespeichert.",
    bookmark_saved: "Lesezeichen gespeichert.",
    bookmark_added: "Lesezeichen hinzugefügt.",
    failed_to_bookmark_please_try_again: "Lesezeichen fehlgeschlagen. Bitte versuche es erneut.",
    special_characters_are_not_allowed: "Sonderzeichen sind nicht erlaubt.",
    home_screen: "Startbildschirm",
    privacy_policy_popup_text_description:
        "Ich verstehe und bin damit einverstanden, meine Kamera freiwillig zu verwenden, um einen Blick auf meine Umgebung zu werfen und die technischen Probleme zu lösen, die ich habe. Ich verstehe, dass keine Aufnahme gemacht oder gespeichert wird. Ich kann die Freigabefunktion jederzeit deaktivieren. Ich werde die Kamera nicht auf Bereiche, Personen oder Gegenstände richten, deren Bild ich nicht teilen möchte. Ich bestätige auch, dass ich die Datenschutzerklärung gelesen und ihr zugestimmt habe.",
    audio_issue_ios: "Audioproblem?",
    toggle_mic_icon_guest_msg: "Schalten Sie das rote Mikrofon- / Kamerasymbol oben um oder verwenden Sie Audio von Telefonanrufen. (PSTN)",
    toggle_mic_icon_agent_msg:
        "Fordern Sie den iOS-Benutzer auf, das rote Mikrofon- / Kamerasymbol oben umzuschalten oder Audio von Telefonanrufen zu verwenden. (PSTN)",
    audio_ios_msg_read_more: "Weiterlesen",
    error_occured_in_processing_the_request: "Bei der Verarbeitung der Anforderung ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    markup_ocr_upload_timeout: "Duurt langer dan normaal.",
    cancel_markup: "Markering annuleren",
    markup_cancelled: "Markup geannuleerd",
    cancel_ocr: "Annuleer Extract text",
    ocr_cancelled: "Extraheer tekst geannuleerd",
    click_here: "Klik hier",
    to_return_to_video_and_try_again: "om terug te keren naar Video en probeer het opnieuw.",
    test_connection: "Testverbindung",
    markup_exit: "stoppte Markup",
    ocr_exit: "gestoppt Text extrahieren",
    camera: "Kamera",
    camera_blocked: "Kamera blockiert",
    microphone: "Mikrofon",
    microphone_blocked: "Mikrofon blockiert",
    speakers: "Sprecher",
    speakers_blocked: "Lautsprecher blockiert",
    grant_permission: "Erlaubnis erteilen",
    play_test_sound: "Testton abspielen",
    call_settings: "Anrufeinstellungen",
    allow_access_to_camera: "Ermöglichen Sie den Zugriff auf Ihre Kamera.",
    allow_access_to_mic: "Ermöglichen Sie den Zugriff auf Ihr Mikrofon.",
    default_label: "Standard",
    do_not_rotate_the_phone_OCR_message: "Für ein besseres Seherlebnis drehen Sie das Gerät bitte nicht, während Text extrahieren aktiviert ist.",
    browser_not_supported: "Browser wird nicht unterstützt",
    your_browser_not_support_video: "Ihr Browser unterstützt keine Videoanrufe.",
    open_link_in_google_samsung_browser:
        "Bitte kopieren Sie diesen Link und fügen Sie ihn in die neueste Version des Google Chrome- oder Samsung-Internetbrowsers ein.",
    open_link_in_safari_browser: "Bitte kopieren Sie diesen Link und fügen Sie ihn in die neueste Version des Safari-Browsers ein.",
    copy_link: "Link kopieren",
    copy_code: "Code kopieren",
    session_code_copy: "Sitzungs-ID in Zwischenablage kopiert.",
    meeting_code_lable: "Besprechungscode",
    add_participant_lable: "Teilnehmer hinzufügen",
    send_this_link_to_guest: "Senden Sie diesen Link an den Gast",
    send_an_email: "eine E-Mail senden",
    or_label: "oder",
    remote_mic_cam_error: "Das Mikrofon / die Kamera des Remote-Teilnehmers weist einen Fehler auf.",
    device_not_supported_or_permi_block: "Entweder wird ihr Gerät nicht unterstützt oder sie haben Berechtigungen blockiert.",
    remote_participant: "Remote-Teilnehmer",
    microphone_unmuted: "Mikrofon nicht stummgeschaltet",
    microphone_muted: "Mikrofon stummgeschaltet",
    camera_on: "Kamera ein",
    camera_off: "Kamera aus",
    error_label: "Error",
    cannot_start_video: "Video kann nicht gestartet werden",
    failed_to_start_video_camera: "Fehler beim Starten der Videokamera.",
    please_select_another_camera_from_call_settings: "Bitte wählen Sie eine andere Videokamera aus den Anrufeinstellungen.",
    please_select_another_video_camera: "Bitte wählen Sie eine andere Videokamera.",
    chat: "Plaudern",
    chat_info: "Chat-Nachrichten sind für alle Anrufer sichtbar. Der Chat-Verlauf verschwindet dauerhaft, wenn Sie die Verbindung trennen.",
    chat_input_placeholder: "Geben Sie eine Nachricht ein",
    participant_connected: "<participantCount> Teilnehmer verbunden",
    click_to_share_invite: "Klicken Sie hier, um die Einladung zu teilen",
    remote_flashlight_not_supported_on_guest_device_or_not_ready:
        "Remote-Taschenlampe wird auf dem Gastgerät nicht unterstützt oder ist nicht bereit",
    pin_a_video_tile_above_to_use_this_feature: "Pin eine Videokachel oben, um diese Funktion zu verwenden",
    pin_video_for_all_participants: "Pin Video für alle Teilnehmer",
    return_to_gallery_view: "Zurück zur Galerieansicht",
    override_own_screen_share: "Ihre Bildschirmfreigabe wird gestoppt. Wollen Sie fortfahren?",
    override_own_video: "Dein Video wird gestoppt. Wollen Sie fortfahren?",
    blur: "Verwischen",
    mask_lable: "Maske",
    view_text: "Aussicht",
    arrow: "Pfeil",
    recording_stopped: "Die Aufnahme wurde gestoppt",
    error_recording_please_try_again: "Fehleraufzeichnung, bitte versuchen Sie es erneut",
    error_recording_wait_or_disconnect_call:
        "Fehleraufzeichnung. Bitte warten Sie, bis der Host die Aufzeichnung beendet hat. Andernfalls können Sie die Verbindung trennen und später wieder beitreten.",
    wait_for_recording: "Bitte warten Sie, während wir mit der Aufnahme beginnen ...",
    max_participant_limit_for_recording:
        "Max. Teilnehmerlimit während der Aufnahme erreicht. Bitte warten Sie, bis der Host die Aufzeichnung beendet hat. Andernfalls können Sie die Verbindung trennen und später wieder beitreten.",
    error_recording_all_participants: "Fehler beim Aufzeichnen aller Teilnehmer.",
    please_stop_and_restart_recording: "Bitte stoppen Sie die Aufnahme und starten Sie sie neu.",
    some_participants_will_not_be_recorded: "Einige Teilnehmer werden nicht aufgezeichnet.",
    participant_limit_reached: "Teilnehmerlimit erreicht.",
    your_account_has_4_participant_limit_while_recording: "Ihr Konto hat maximal 4 Teilnehmer während der Aufnahme.",
    disconnect_call: "Anruf trennen",
    record_title: "Aufzeichnung",
    stop_recording_btn: "Höre auf, aufzunehmen",
    back_to: "Zurück zu",
    cam_per_denied_msg: "Einer Ihrer Teilnehmer hat möglicherweise den Kamerazugriff auf seinem Gerät blockiert. Um sie zu führen, sehen Sie bitte",
    mic_per_denied_msg: "Einer Ihrer Teilnehmer hat möglicherweise den Mikrofonzugriff auf seinem Gerät blockiert. Um sie zu führen, sehen Sie bitte",
    cam_mic_per_denied_msg:
        "Einer Ihrer Teilnehmer hat möglicherweise den Zugriff auf Kamera und Mikrofon auf seinem Gerät blockiert. Um sie zu führen, sehen Sie bitte",
    per_denied_common_msg: "Hier finden Sie schnelle Tipps zum Zurücksetzen der Browserberechtigungen.",
    your_camera_block: "Ihre Kamera ist blockiert",
    your_microphone_block: "Ihr Mikrofon ist blockiert",
    your_location_block: "Ihr Standort ist gesperrt",
    we_cannot_access_your_camera: "Wir können nicht auf Ihre Kamera zugreifen.",
    we_cannot_access_your_microphone: "Wir können nicht auf Ihr Mikrofon zugreifen.",
    we_cannot_access_your_location: "Wir können nicht auf Ihren Standort zugreifen.",
    go_to_browser_settings: "Um Zugriff zu gewähren, gehen Sie zu Ihren Browsereinstellungen und klicken Sie hier, um die Seite neu zu laden.",
    still_facing_issue: "Immer noch vor einem Problem?",
    try_the: "Probieren Sie die",
    mobile_app: "App",
    view_help_article: "Hilfeartikel anzeigen",
    enable_or_attach_camera_and_reconnect_call:
        "Sie müssen die Kamera aktivieren oder anschließen, die Seite neu laden und den Anruf erneut verbinden.",
    enable_or_attach_microphone_and_reconnect_call:
        "Sie müssen das Mikrofon aktivieren oder anschließen, die Seite neu laden und den Anruf erneut verbinden.",
    start_rec_label: "Starten Sie Rec.",
    stop_rec_label: "Stop Rec.",
    start_recording_tooltip_label: "Starte die Aufnahme",
    click_here_label: "klicken Sie hier",
    cam_per_denied_title: "Remote-Teilnehmerkamera blockiert",
    mic_per_denied_title: "Remote-Teilnehmermikrofon blockiert",
    cam_mic_per_denied_title: "Remote-Teilnehmerkamera und Mikrofon blockiert",
    these_instructions: "diese Anweisungen",
    Whisper_on: "Flüstern Sie weiter",
    Whisper_off: "Flüstern Sie aus",
    enable_whisper_tooltip_label: "Aktivieren Sie das Flüstern, um mit dem Host zu sprechen",
    host_can_hear_you_now: "Der Gastgeber kann Sie jetzt hören",
    mediate_lable: "Vermitteln",
    join_call_as_participant: "Nehmen Sie als Teilnehmer am Anruf teil",
    observer_lable: "Beobachter",
    silent_observer_connect_alert_popup: "Als Beobachter verbunden. Ihr Mikrofon und Ihre Kamera sind stummgeschaltet.",
    click_mediate_if_you_would_like_to_join_as_a_participant: 'Klicken Sie auf "Vermitteln", wenn Sie als Teilnehmer beitreten möchten.',
    guest_lable: "Gast",
    Silent_observer_lable: "Stiller Beobachter",
    invite_participant_tooltip_lable: "Mikrofon und Kamera werden für Silent Observer stummgeschaltet und sind für Gastteilnehmer nicht sichtbar.",
    send_link_silent_observer: "Senden Sie diesen Link an den stillen Beobachter.",
    join_as_mediator_title: "Als Mediator mitmachen?",
    join_as_mediator_popup_description:
        "Sind Sie sicher, dass Sie als Teilnehmer am Anruf teilnehmen möchten? Klicken Sie unten auf Bestätigen und dann im nächsten Bildschirm auf Verbinden, um als Teilnehmer (Mediator) beizutreten.",
    from_participant: "Vom Teilnehmer",
    download_key: "Herunterladen",
    download_not_supported_text: "Der Download wird auf Ihrem Gerät nicht unterstützt.",
    undo: "Rückgängig machen",
    redo: "Wiederholen",
    color_label: "Farbe",
    overall_experience: "Gesamterlebnis?",
    leave_comment: "Hinterlasse einen Kommentar (optional)",
    sent: "Geschickt",
    send: "Senden",
    view_unavailable: "Ansicht nicht verfügbar",
    whisper_label: "Flüstern",
    thanks: "Vielen Dank!",
    stop_recording_tooltip_label: "Kehren Sie zum Galeriemodus zurück, um die Aufnahme zu beenden.",
    save_image: "Bild speichern",
    screenshare_mweb_text:
        "Für die Bildschirmfreigabe von Ihrem Gerät ist eine App erforderlich. Bitte verbinden Sie diese Sitzung über die mobile App.",
    disconnect_and_launchapp_btn: "App trennen und starten",
    device_battery_low: "Gerätebatterie schwach",
    batteryinfo_tooltip: "Informationen zur Gerätebatterie",
    notes_lable: "Anmerkungen",
    new_note_lable: "Neue Notiz",
    only_visible_to_you: "Nur für Sie sichtbar",
    empty_note: "Leere Notiz",
    title_lable: "Titel",
    delete_lable: "Löschen",
    delete_Note: "Hinweis löschen",
    want_delete_this_note: "Möchten Sie diese Notiz wirklich löschen?",
    failed_delete_note: "Notiz konnte nicht gelöscht werden.",
    note_deleted_successfully: "Hinweis gelöscht",
    failed_edit_note: "Notiz konnte nicht bearbeitet werden.",
    note_edited_successfully: "Hinweis aktualisiert",
    failed_add_note: "Hinweis konnte nicht hinzugefügt werden.",
    note_added_successfully: "Hinweis hinzugefügt",
    screenshare_mweb_title: "App-Download erforderlich",
    screenshare_mweb_desc1: "Für die Bildschirmfreigabe von Ihrem Gerät ist eine App erforderlich.",
    screenshare_mweb_desc2: "um die App herunterzuladen.",
    upcoming_event: "Kommende Veranstaltung",
    scheduled_to_start_in: "Geplant für den Start in",
    please_wait_for_the_host_to_start_this_event:
        "Bitte warten Sie, bis der Gastgeber diese Veranstaltung gestartet hat, und versuchen Sie es erneut.",
    image_deleted: "Bild gelöscht",
    failed_to_delete_image: "Bild konnte nicht gelöscht werden",
    are_you_sure_you_want_to_delete_image: "Möchten Sie dieses Bild wirklich dauerhaft löschen?",
    delete_image_title: "Lösche Bild",
    schedule_to_start_in_a_few_seconds: "Geplant, um in wenigen Sekunden zu starten.",
    edit_label: "Bearbeiten",
    scan_code_lable: "Code scannen",
    scan_code_result: "Scan-Code-Ergebnis",
    extract_text_result: "Textergebnis extrahieren",
    scan_code_result_not_found: "QRcode / Barcode konnte nicht vom Bild gescannt werden. Bitte versuchen Sie es erneut mit einem klaren Bild.",
    host_features_will_not_be_available_when_using_app: "Host-Funktionen sind bei Verwendung der App nicht verfügbar.",
    note_colon: "Hinweis:",
    leave_lable: "Verlassen",
    are_you_sure_you_want_to_leave_this_call: "Sind Sie sicher, dass Sie diesen Anruf verlassen möchten?",
    supported_browser_versions: "Unterstützte Browserversionen.",
    see: "Sehen",
    has_sent_you_link_for_video_conference: "<company_name> hat Sie einen Link fur die Live-Videokonferenz gesendet.",
    join_the_session: "Nehmen Sie an der Sitzung teil",
    other: "Andere",
    share_invitation_with_others: "Sitzungseinladung mit anderen teilen",
    copy_invitation: "Sitzungseinladung kopieren",
    copy_invitation_desc: "Kopieren Sie den Einladungstext mit der geplanten Zeit und senden Sie ihn manuell",
    copied: "Kopiert!",
    copy_session_code: "Sitzungs-ID kopieren",
    copy_link_to_share: "Kopiere den Link zum Teilen",
    reference: "Referenz",
    session_invitation_copied: "Sitzungseinladung in Zwischenablage kopiert.",
    guest_url_copy: "Gast-URL in die Zwischenablage kopiert.",
    observer_url_copied: "Beobachter-URL in Zwischenablage kopiert.",
    sms_sent_label: "SMS gesendet!",
    email_sent_label: "E-Mail gesendet!",
    invite_sent_successfully: "Verschickt Einladung erfolgreich",
    sms_label: "SMS",
    copy: "Kopieren",
    email: "Email",
    enter_valid_email: "Geben Sie eine gültige E-Mail-Adresse ein.",
    limit_exceeded: "Limit überschritten",
    enter_email_send: "Geben Sie E-Mail ein, um eine Einladung zu senden",
    send_invitaion_lable: "Einladung senden",
    enter_mobile_number_lable: "Geben Sie die Handynummer ein",
    enter_valid_mobile: "Geben Sie eine gültige Mobilfunknummer ein.",
    new_email_address: "E-Mail-Addresse",
    mobile_number: "Handynummer",
    video_quality: "Videoqualität",
    low_bandwidth: "Niedrige Bandbreite",
    adaptive: "Adaptiv",
    high_quality: "Hohe Qualität",
    wait_for_the_call_to_start: "Warten Sie, bis der Anruf beginnt",
    call_disconnected: "Anruf getrennt",
    dont_show_this_again: "Zeig das nicht noch einmal",
    invite_participant_lable: "Teilnehmer einladen",
    saved_label: "Gerettet!",
    show_stream: "Show",
    hide_stream: "Ausblenden",
    camera_permission_required_title: "Kameraerlaubnis erforderlich",
    camera_permission_required_disc1: "Um Live-Videos zu teilen, aktivieren Sie bitte die Kameraberechtigung in Ihren Browsereinstellungen",
    reload_page_disc: "um die Seite neu zu laden.",
    location_permission_required_title: "Standortgenehmigung erforderlich",
    microphone_permission_required_title: "Mikrofongenehmigung erforderlich",
    confirmation_lable: "Ich kann bestätigen, dass ich das gelesen habe und damit einverstanden bin",
    live_location: "Live-Standort",
    no_one_shared_location: "Niemand hat ihren Standort geteilt",
    it_was_great_lable: "Es war toll",
    not_so_great_lable: "Nicht so toll",
    link_copied: "Link kopiert",
    microphone_publication_description: "Mikrofon nicht gefunden oder wird möglicherweise von einer anderen Anwendung verwendet.",
    please_close_all_other_application:
        "Bitte schließen Sie alle anderen Anwendungen, die möglicherweise das Mikrofon verwenden, und versuchen Sie es erneut.",
    app_to_share_your_device_screen: "Setze diesen Anruf in der App fort, um deinen Gerätebildschirm zu teilen",
    launch_app: "App starten",
    screen_share_requires_app: "Für die Bildschirmfreigabe ist eine App erforderlich.",
    only_takes_few_seconds: "Dies dauert nur wenige Sekunden.",
    download_app_from_app_store_and_then_return_page: "Laden Sie die App aus dem App Store herunter und kehren Sie dann zu dieser Seite zurück.",
    click_to_download_app: "Klicken Sie hier, um die App herunterzuladen",
    go_to_Step_2: "Wenn Sie die App bereits heruntergeladen haben, gehen Sie zu Schritt 2",
    next_lable: "Nächster",
    rejoin_the_call_in_app: "Erneut an dem Anruf in der App teilnehmen",
    step2_screen_share_description:
        "Nachdem Sie die App heruntergeladen haben, können Sie diesem Anruf in der App wieder beitreten und „Screen Share“ auswählen, um Ihren mobilen Bildschirm zu teilen.",
    disconnect_the_call_in_browser: "Dadurch wird der Anruf im Browser getrennt",
    back_btn_lable: "Zurück",
    rejoin_call_in_app: "Anruf in der App erneut beitreten",
    step_one: "Schritt 1",
    step_two: "Schritt 2",
    beta_release_tag_des1: "Diese Funktion befindet sich derzeit in der Beta-Version.",
    email_support_feedback: "Bitte senden Sie eine E-Mail an support@blitzz.co, um Ihr Feedback zu teilen.",
    would_you_like_to_exit_markup: "Möchten Sie Markup beenden?",
    current_position: "Aktuelle Position",
    start_point: "Startpunkt",
    live_captions: "Live-Untertitel",
    starting_label: "Beginnend...",
    live_captions_started: "Live-Untertitel gestartet.",
    spoken_language_is_set_to_english: "Die gesprochene Sprache ist auf Englisch eingestellt.",
    click_to_open_more_information: "Klicken Sie hier, um weitere Informationen zu öffnen",
    open_in_safari_chrome_or_install_mobile_app:
        "Bitte kopieren Sie diesen Link und fügen Sie ihn in die neueste Version von Safari oder Google Chrome Browser ein oder installieren Sie unsere Mobile App und versuchen Sie es erneut.",
    continue_without_name: "Ohne Namen fortfahren",
    enter_your_name: "Gib deinen Namen ein",
    ignore: "Ignorieren",
    screen_share_info:
        "Um einen Infinitiv-Spiegel zu vermeiden, geben Sie nicht Ihren gesamten Bildschirm oder Ihr Browserfenster frei. Geben Sie stattdessen nur einen Tab oder ein anderes Fenster frei.",
    screen_share_to_everyone: "Sie teilen den Bildschirm mit allen",
    stop_share_screen: "Beenden Sie die Bildschirmfreigabe",
    unable_to_start_the_video_please_download_the_app_to_continue:
        "Das Video kann nicht gestartet werden. Bitte laden Sie die App herunter, um fortzufahren.",
    upload: "Hochladen",
    from_device: "Von Gerät",
    from_camera: "Von der Kamera",
    upload_failed_files: "Fehlerhafte Dateien hochladen",
    uploaded_max_file: "Sie haben die maximal zulässige Anzahl an Dateien hochgeladen.",
    upload_files: "Daten hochladen",
    upload_limit_reached: "Upload-Limit erreicht",
    drop_for_upload_or_select: "Zum Hochladen hierher ziehen oder auswählen",
    upload_20_file: "Laden Sie bis zu 20 Dateien gleichzeitig hoch.",
    max_size_20MB: "max. Dateigröße <fileSize> MB.",
    cancel_upload: "Hochladen abbrechen",
    cancel_upload_alert: "Hochladen abbrechen?",
    file_details_deleted: "Alle Details, die Ihren Dateien hinzugefügt wurden, werden gelöscht.",
    uploaded_files: "Hochgeladene Dateien",
    capture_image: "Bild aufnehmen",
    participant_uploading_file_msg: "Bitte warten Sie, während der andere Teilnehmer Dateien hochlädt.",
    previous: "Vorherige",
    max_file_count: "Sie können maximal <fileCount> Dateien gleichzeitig hochladen.",
    removed_more_than_20MB_file: "Dateien mit einer Größe von mehr als <fileSize> MB werden entfernt.",
    uploading_files: "Datei(en) hochladen",
    upload_failed_file_count: "Upload fehlgeschlagen: <numberOfFailedFiles> Dateien wurden nicht hochgeladen.",
    add_caption: "Bildunterschrift hinzufügen...",
    uploaded_files_of_a_maximum: "<successCount> -Datei(en) mit maximal <totalCount>",
    you_have_selected_the_maximum_number_of_files_allowed: "Sie haben die maximal zulässige Anzahl von Dateien ausgewählt.",
    upload_max_count: "Laden Sie maximal <remainingCount> Datei(en) hoch.",
    image_upload_msg: "Bitte warten Sie, während die Bilder hochgeladen werden",
    finished_uploading: "Hochladen abgeschlossen",
    upload_files_msg: "Daten hochladen",
    uploading_dots: "Hochladen…",
    loading_image_counter: "Bild <counter> von <totalCount>",
    closing_tab: "Schließende Registerkarte",
    close_tab: "Tab schließen",
    return_to_home_screen: "Rückkehr zum Startbildschirm",
    session_code_expire_msg: "Dieser Link wurde geschlossen",
    view_call_logs: "Anrufprotokolle anzeigen",
    measurements: "Messungen",
    copy_all: "Kopiere alles",
    measure: "Messen",
    view_supported_device: "Unterstützte Geräte anzeigen",
    device_not_support_google_play_service: "Das Gerät des Teilnehmers unterstützt den für 3D-Messungen erforderlichen Google Play-Dienst nicht",
    device_not_compatible_for_measurement: "Gerät nicht für Messung geeignet",
    device_required_update_google_play_service:
        "Das Gerät des Teilnehmers erfordert eine Aktualisierung des Google Play-Dienstes, um die 3D-Messung zu starten.",
    device_required_google_play_service: "Auf dem Gerät des Teilnehmers muss der Google Play-Dienst installiert werden, um die 3D-Messung zu starten",
    app_required_update_for_measurement: "Unterstützendes App-Update für Messung erforderlich",
    app_required_for_measurement: "Unterstützende App für die Messung erforderlich",
    preparing_ar_measurement: "Ansicht für Messung vorbereiten...",
    measurement_copied_msg: "Messungen in die Zwischenablage kopiert",
    ready_for_measurement: "Bereit für die Messung",
    move_device_to_start: "Bewegen Sie das Gerät zum Starten",
    tacking_not_available: "Tracking ist nicht verfügbar",
    camera_use_bu_another_app: "Die Kamera wird von einer anderen App verwendet",
    more_light_required: "Mehr Licht erforderlich",
    move_further_away: "Bewegen Sie sich weiter weg",
    slow_down: "Langsamer",
    measurement_cancelled: "Messung abgebrochen",
    app_required: "Für diese Funktion ist ein App-Download erforderlich. <learnmore>",
    learn_more: "Mehr erfahren",
    ar_measurement_description_step2:
        "Nachdem Sie die App heruntergeladen haben, können Sie diesem Anruf in der App wieder beitreten und „Messen“ auswählen, um die AR-Messung zu starten",
    ar_measurement_description_step1:
        "Die Augmented-Reality-Messfunktion ermöglicht es Ihnen, Objekte in 3D zu messen und erfordert einen App-Download",
    app_to_support_ar_measurement: "Setzen Sie diesen Aufruf in der App fort, um die AR-Messung zu unterstützen",
    find_surface_to_measure: "Finden Sie eine nahe gelegene Oberfläche zum Messen",
    measurement_toast_note_to_guide_user: "Hinweis: Maße sind ungefähre Angaben.",
    measurement_toast_msg_to_guide_user:
        "Um optimale Ergebnisse zu erzielen, verwenden Sie „Messen“ für gut definierte Objekte, die sich 0,5 bis 3 Meter (2 bis 10 Fuß) von Ihrem Telefon entfernt befinden.",
    having_audio_issue: "Haben Sie ein Audioproblem?",
    remote_participant_voice_not_coming_description:
        "Sieht so aus, als hätten Sie Schwierigkeiten, die Stimme anderer Teilnehmer zu hören, oder haben derzeit ein Audioproblem.",
    workaround_action_for_remote_audio_not_coming: "<click_here> , um eine schnelle Problemumgehung anzuwenden.",
    click_here_for_audio_label: "Klicken Sie hier",
    measurement_copyall_msg: "Messung(en) in die Zwischenablage kopiert",
    armarkup_cancelled: "AR-Markup abgebrochen",
    device_not_support_google_play_service_for_markup:
        "Das Gerät des Teilnehmers unterstützt den für 3D-Markup erforderlichen Google Play-Dienst nicht",
    device_required_update_google_play_service_for_markup:
        "Auf dem Gerät des Teilnehmers muss der Google Play-Dienst aktualisiert werden, um 3D-Markup zu starten.",
    device_required_google_play_service_for_markup:
        "Auf dem Gerät des Teilnehmers muss der Google Play-Dienst installiert werden, um 3D-Markup zu starten",
    device_not_compatible_for_AR_Markup: "Gerät nicht kompatibel mit AR Markup",
    app_required_update_for_AR_Markup: "Unterstützendes App-Update für AR-Markup erforderlich",
    app_required_for_AR_Markup: "Unterstützende App für AR Markup erforderlich",
    preparing_view_for_ar_markup: "Ansicht für AR-Markup wird vorbereitet...",
    AR_Markup_Lable: "AR-Markup",
    armarkup_toast_msg_to_guide_user:
        "Verwenden Sie Markup für beste Ergebnisse auf gut definierten Objekten, die sich 0,5 bis 3 Meter (2 bis 10 Fuß) von Ihrem Telefon entfernt befinden.",
    ar_live_streaming_ready_to_markup: "AR-Live-Streaming bereit zum Markup.",
    ar_markups_cleared_for_all_users: "AR-Markups für alle Benutzer gelöscht.",
    ar_live_streaming_marking_stopped: "AR-Live-Streaming-Markierung gestoppt",
    agent_has_ended_ar_markup_cannot_continue_without_agent:
        "Der Agent hat das AR-Markup beendet. AR-Markup kann ohne Agent nicht fortgesetzt werden",
    ar_markup_cancelled: "AR-Markup abgebrochen",
    ready_for_ar_markup: "Bereit für AR-Markup",
    max_ar_arrow_limit_toast_message: "Pfeillimit erreicht. Bitte verwenden Sie „Alle löschen“, um weitere hinzuzufügen.",
    video_paused: "Video pausiert",
    discard_label: "Verwerfen",
    discard_image_label: "Bild verwerfen",
    save_image_label: "Bild speichern",
    go_room_call_limit_reached: "Das Anruflimit für „Gehe zum Zimmer“ wurde erreicht",
    circle: "Kreis",
    arrow_with_text: "Pfeil mit Text",
    add_shadow_and_stroke: "Fügen Sie Schatten und Strich hinzu",
    font_label: "Schriftart:",
    file_type_not_supported: "Dateityp(en) wird nicht unterstützt",
    crt_acnt_enter_confirm_password: "",
    create_new_note_description: "Klicken Sie unten auf die Schaltfläche „Neue Notiz“, um mit dem Erstellen von Notizen zu beginnen",
    remote_user_stream_interrupted: "Remote-Benutzer-Stream unterbrochen",
    audio_disabled_by_admin: "Audio vom Administrator deaktiviert",
    audio_disabled: "Audio deaktiviert",
    dont_show_again: "Nicht mehr anzeigen",
    whatsapp_sent_label: "WhatsApp-Einladung gesendet!",
    whatsapp_label: "WhatsApp",
    having_an_issue_with_joining_the_call: "Haben Sie ein Problem damit, dem Anruf beizutreten?",
    to_perform_network_check: "Netzwerkprüfung durchführen",
    you_were_removed_from_the_call_by_the_host: "Sie wurden vom Gastgeber aus dem Anruf entfernt",
    you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now:
        "Sie wurden vom Gastgeber aus dem Anruf entfernt und können jetzt nicht erneut beitreten.",
    host_removed_you_from_the_call: "Der Gastgeber hat Sie aus dem Anruf entfernt.",
    unable_to_join_the_call: "Kann dem Anruf nicht beitreten",
    host_muted_your_microphone: "Der Gastgeber hat Ihr Mikrofon stummgeschaltet.",
    unmute_your_microphone: "Schalten Sie Ihr Mikrofon stumm",
    host_invites_you_to_speak_unmute_your_microphone_when_ready:
        "Der Gastgeber fordert Sie zum Sprechen auf. Schalten Sie Ihr Mikrofon ein, wenn Sie bereit sind.",
    got_it: "Habe es",
    unmute_mic: "Mikrofon-Stummschaltung aufheben",
    host_turned_off_your_camera: "Der Gastgeber hat Ihre Kamera ausgeschaltet.",
    turn_your_camera_on: "Schalten Sie Ihre Kamera ein",
    host_invites_you_to_turn_your_camera_on: "Der Gastgeber fordert Sie auf, Ihre Kamera einzuschalten.",
    turn_camera_on: "Kamera einschalten",
    start_sharing_your_screen: "Beginnen Sie mit der Freigabe Ihres Bildschirms",
    host_invites_you_to_share_your_screen: "Der Gastgeber lädt Sie ein, Ihren Bildschirm freizugeben.",
    share_screen: "Bildschirm freigeben",
    remove_all: "Alle entfernen",
    remove: "Entfernen",
    end_call: "Anruf beenden",
    removing_all_participants_will_end_the_call: "Durch das Entfernen aller Teilnehmer wird der Anruf beendet.",
    are_you_sure_you_want_to_remove_from_this_call: "Möchten Sie <participantName> wirklich aus diesem Anruf entfernen?",
    block_from_rejoining_this_call: "Blockieren Sie <participantName> daran, diesem Anruf erneut beizutreten.",
    turn_all_mics_off: "Schalten Sie alle Mikrofone aus",
    turn_all_cams_off: "Schalten Sie alle Kameras aus",
    ask_to_turn_mic_on: "Bitten Sie darum, das Mikrofon einzuschalten",
    turn_mic_off: "Mikrofon ausschalten",
    turn_cam_off: "Kamera ausschalten",
    ask_to_turn_cam_on: "Bitten Sie darum, die Kamera einzuschalten",
    ask_to_share_screen: "Bitten Sie um Bildschirmfreigabe",
    having_a_video_problem: "Haben Sie ein Videoproblem?",
    ios_play_pause_modal_body_text: "",
    play_video: "Video abspielen",
    camera_request_sent: "Kameraanfrage gesendet.",
    waiting_for_host_approval: "Warte auf die Genehmigung des Hosts.",
    microphone_request_sent: "Mikrofonanfrage gesendet.",
    camera_request_denied: "Kameraanforderung abgelehnt.",
    click_the_camera_icon_if_you_need_to_request_again: "Klicken Sie auf das Kamerasymbol, wenn Sie eine erneute Anfrage stellen müssen.",
    microphone_request_denied: "Mikrofonanforderung abgelehnt.",
    click_the_mic_icon_if_you_need_to_request_again: "Klicken Sie auf das Mikrofonsymbol, wenn Sie eine erneute Anfrage stellen müssen.",
    deny: "Leugnen",
    allow: "Erlauben",
    user_wants_to_start_their_camera: "<ParticipantName> möchte sein <micOrCam> starten",
    error_in_processing_live_caption_please_retry: "Fehler beim Verarbeiten der Live-Untertitel. Bitte versuchen Sie es erneut.",
    virtual_background: "Virtueller Hintergrund",
    upload_image: "Bild hochladen",
    remove_image: "Bild entfernen",
    remove_background_image: "Hintergrundbild entfernen",
    are_you_sure_you_want_to_remove_background_image: "Möchten Sie das Hintergrundbild wirklich entfernen?",
    unsupported_file_format: "Nicht unterstütztes Dateiformat.",
    the_maximum_file_size_supported_is_in_mb: "Die maximal unterstützte Dateigröße beträgt <size> MB.",
    no_effect: "Keine Wirkung",
    blur_background: "Hintergrund verwischen",
    default_image: "Standardbild",
    virtual_background_not_supported: "Virtueller Hintergrund wird nicht unterstützt.",
    remove_from_call: "Aus dem Anruf entfernen",
    enable_offline_mode: "Offline-Modus aktivieren",
    offline_mode_enabled: "Offline-Modus aktiviert",
    your_images_will_upload_when_you_reconnect: "Ihre Bilder werden hochgeladen, wenn Sie die Verbindung wiederherstellen.",
    please_keep_this_screen_open: "Bitte lassen Sie diesen Bildschirm geöffnet.",
    max_images_upload: "Max <count> Bilder",
    remaining_image_count_label: "<remainingCount> von <totalCount> Bildern",
    selected_images: "Ausgewählte Bilder",
    offline_uploads_are_not_supported_in_private_mode: "Offline-Uploads werden im privaten Modus nicht unterstützt.",
    please_switch_to_a_normal_browser_tab_to_use_this_feature: "Bitte wechseln Sie zu einem normalen Browser-Tab, um diese Funktion zu verwenden.",
    guest_is_using_a_private_browser_window: "Der Gast verwendet ein privates Browserfenster.",
    offline_upload_mode_is_not_supported_in_this_case: "Der Offline-Upload-Modus wird in diesem Fall nicht unterstützt.",
    some_images_failed_to_upload_due_to_a_network_error: "Aufgrund eines Netzwerkfehlers konnten einige Bilder nicht hochgeladen werden.",
    closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode:
        "Wenn Sie dieses Modal schließen, werden alle Bilder verworfen, die Sie im Offlinemodus ausgewählt haben.",
    live_captions_stopped: "Live-Untertitel gestoppt.",
    translate: "Übersetzen",
    auto_translate: "Automatische Übersetzung",
    your_language: "Ihre Sprache",
    translation_info_text: "Nachrichten anderer Teilnehmer werden automatisch in die von Ihnen gewählte Sprache übersetzt.",
    translating: "Übersetzung...",
    show_original: "Original anzeigen",
    show_translation: "Übersetzung anzeigen",
    translated: "Übersetzt",
    audio_translation: "Übersetzen",
    audio_translation_setup: "Audio-Übersetzung",
    they_speak: "Sie sprechen",
    i_want_to_hear: "Ich möchte hören",
    start_translation: "Übersetzung starten",
    stop_translation: "Übersetzung stoppen",
    starting_translation: "Übersetzung wird gestartet...",
    translation_started: "Audio-Übersetzung gestartet.",
    translation_stopped: "Audio-Übersetzung gestoppt.",
    translation_error: "Übersetzungsfehler. Bitte versuchen Sie es erneut.",
    translation_active: "Übersetzung aktiv",
    voice_type: "Stimme",
    voice_female: "Weiblich",
    voice_male: "Männlich",
};

export default de;
